module.exports = __webpack_public_path__ + "img/successfully-icon.382483b4.png";